import * as React from 'react';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import i18n from '@i18next/i18n';
import { TOOLBAR_AUDIO } from '@src/framework/editor/src/img/pageIndex';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ENV } from '@src/slide/application/service/edit-extension/edit-extension-export';

/**
 相比与 insert-audio ，insert-audio-old 没有下拉框、没有“从腾讯文档上传”的功能
*/

export const config = {
    id: ActionType.INSERT_AUDIO,
    icon: TOOLBAR_AUDIO,
    content: i18n.t('音频'),
    twdConfig: {
        opername: TDWOperationType.DOC_ALL,
        module: TDWModuleType.LOCAL_FILES,
        action: TDWActionType.AUDIO,
        notReportVer5: true,
    },
};


export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: i18n.t('插入音频'),
        icon: <img src={config.icon} alt={''} />,
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''} />,
        text: config.content,
        style: {
        },
        tooltip: i18n.t('插入音频'),
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
    {
        name: wrapIdForBig(`${ActionType.INSERT_AUDIO}-parent`),
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
        },
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
];
